import RichTextBox from "./src/RichTextBox";

RichTextBox.install = function (Vue) {
    Vue.component(RichTextBox.name, RichTextBox)
}

export default RichTextBox